import { z } from 'zod';
import { normalizeCreditor, normalizeEmail } from '../common/string.utils';
import { UsersClaims } from './claims';

export const bulkUpsertUserSchema = z.object({
  external_creditor_id: z.string().min(1).max(255).transform(normalizeCreditor),
  name: z.string().min(1).max(255).nullish(),
  email: z.string().email().nullish().transform(normalizeEmail),
  send_invite: z.boolean().nullish(),
  active: z.boolean().nullish(),
});

export const bulkUpsertUserPermissionType = z.enum([
  UsersClaims.CREDITORS_VIEW_PERMISSION,
  'team',
  'profile',
]);

export const bulkUpsertUserPermissionSchema = z.object({
  external_creditor_id: z.string().max(255).transform(normalizeCreditor),
  type: bulkUpsertUserPermissionType,
  value: z.string(),
});

export const columnCreditorAttributesSchema = z.object({
  external_creditor_id: z.string().min(1).max(255),
  name: z.string().min(1).max(255).nullish(),
  email: z.string().min(1).max(255).nullish(),
  send_invite: z.string().min(1).max(255).nullish(),
  active: z.string().min(1).max(255).nullish(),
});

export const bulkUpsertUserQuerySchema = z.object({
  tab_id: z.number().int(),
  column_creditor_attributes: columnCreditorAttributesSchema,
});

export const columnCreditorPermissionsSchema = z.object({
  external_creditor_id: z.string().min(1).max(255),
  type: bulkUpsertUserPermissionType,
  value: z.string().min(1).max(255),
});

export const bulkUpsertUserPermissionQuerySchema = z.object({
  tab_id: z.number().int(),
  column_creditor_permissions: columnCreditorPermissionsSchema,
});
